import { Box, Card, Group, Stack, Text, TextInput } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type PaletteColourFieldProps = {
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  onFocus: () => void;
  onBlur: () => void;
};

export default function PaletteColourField({
  label,
  description,
  value,
  onChange,
  onFocus,
  onBlur,
}: PaletteColourFieldProps) {
  return (
    <Card withBorder radius="md" p="md">
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap="md" align="center" wrap="nowrap">
          <Box
            style={{
              position: 'relative',
              width: 44,
              height: 44,
              flexShrink: 0,
              borderRadius: '50%',
              overflow: 'hidden',
              border: '1px solid var(--mantine-color-gray-3)',
            }}
          >
            <input
              type="color"
              aria-label={`${label} colour picker`}
              value={value}
              onChange={event => onChange(event.currentTarget.value)}
              style={{
                position: 'absolute',
                top: -8,
                left: -8,
                width: 'calc(100% + 16px)',
                height: 'calc(100% + 16px)',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
              }}
            />
          </Box>
          <Stack gap={2}>
            <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.7">
              {label}
            </Text>
            {description && (
              <Text size="xs" c="gray.6" lh={1.2}>
                {description}
              </Text>
            )}
          </Stack>
        </Group>
        <TextInput
          aria-label={`${label} hex colour`}
          value={value}
          onChange={event => onChange(event.currentTarget.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          w={110}
        />
      </Group>
    </Card>
  );
}
